import directive from './directive'
import Vue from 'vue'
const install = function () {
    Vue.directive("SupKeepScrollPostion",directive);
}
if(!Vue.prototype.$isServer){
    Vue.use(install);
}
directive.install=install;
export default directive;
